import { render, staticRenderFns } from "./BaseTBodyLoading.vue?vue&type=template&id=7bdd901f&"
import script from "./BaseTBodyLoading.vue?vue&type=script&lang=js&"
export * from "./BaseTBodyLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports